export interface EraDef {
  id: string
  labelZh: string
  labelEn: string
  /** Normalized range [start, end) covering [0,1] without holes */
  range: [number, number]
  assetKey: string
  folder: string
  /** Fallback sky colors when texture missing [top, mid, bottom] */
  colors: [string, string, string]
}

/** timeValue 0 = deep past / big bang, 1 = modern present */
export const ERAS: EraDef[] = [
  {
    id: 'bigbang',
    labelZh: '大爆炸 · 原初',
    labelEn: 'Big Bang',
    range: [0.0, 0.12],
    assetKey: 'bigbang',
    folder: '00-bigbang',
    colors: ['#1a0533', '#ff6b35', '#ffd166'],
  },
  {
    id: 'nebula',
    labelZh: '星云 · 星系',
    labelEn: 'Nebula',
    range: [0.12, 0.28],
    assetKey: 'nebula',
    folder: '01-nebula',
    colors: ['#050816', '#3d1a78', '#7b2cbf'],
  },
  {
    id: 'dinosaur',
    labelZh: '恐龙时代',
    labelEn: 'Dinosaur Age',
    range: [0.28, 0.48],
    assetKey: 'dinosaur',
    folder: '02-dinosaur',
    colors: ['#0b1f0a', '#2d6a1e', '#87a96b'],
  },
  {
    id: 'indigenous',
    labelZh: '史前 · 原住民',
    labelEn: 'Prehistoric',
    range: [0.48, 0.64],
    assetKey: 'indigenous',
    folder: '03-indigenous',
    colors: ['#1c1408', '#8b5a2b', '#d4a574'],
  },
  {
    id: 'historical',
    labelZh: '历史城市',
    labelEn: 'Historical City',
    range: [0.64, 0.8],
    assetKey: 'historical',
    folder: '04-historical',
    colors: ['#1a1a2e', '#4a3f35', '#c9a66b'],
  },
  {
    id: 'modern',
    labelZh: '现代都市',
    labelEn: 'Modern City',
    range: [0.8, 1.0],
    assetKey: 'modern',
    folder: '05-modern',
    colors: ['#0a0e17', '#1b3a4b', '#00d4ff'],
  },
]

export const BLEND_WIDTH = 0.04
export const INITIAL_TIME_VALUE = 0.92
export const MAX_TIME_SPEED = 0.28
